// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__35Nkv","selects":"Documents_selects__1QzI_"};